import { useQuery } from '@tanstack/react-query';

import { getCreditRefundFrequency } from '~/services/OrdersService';

export const creditRefundFrequencyQueryKeys = {
  all: ['creditRefundFrequency'] as const,
  details: () => [...creditRefundFrequencyQueryKeys.all, 'detail'] as const,
  detail: (userId: string) => [...creditRefundFrequencyQueryKeys.details(), userId] as const,
};

/**
 * Self-service credit refunds the customer has received in the rolling window, and whether
 * that has blocked further ones.
 */
export function useGetCreditRefundFrequency(userId: string, enabled = true) {
  return useQuery({
    queryKey: creditRefundFrequencyQueryKeys.detail(userId),
    queryFn: async ({ signal }) => {
      return await getCreditRefundFrequency(userId, signal);
    },
    enabled: !!userId && enabled,
  });
}
